
import React from 'react';
import { BulkExport } from './exports/BulkExport';
import { TableExport } from './exports/TableExport';
import { TableName } from './exports/exportUtils';

export const ExportsManagement = () => {
  const [isExporting, setIsExporting] = React.useState(false);

  const tableConfigs: Array<{ name: TableName; pretty: string }> = [
    { name: 'tips', pretty: 'Tips' },
    { name: 'prizes', pretty: 'Prizes' },
    { name: 'winners', pretty: 'Winners' },
    { name: 'universities', pretty: 'Universities' },
    { name: 'prize_allocations', pretty: 'Prize Allocations' },
    { name: 'prize_allocation_resets', pretty: 'Allocation Resets' },
    { name: 'user_roles', pretty: 'User Roles' }
  ];

  return (
    <div className="space-y-8">
      <BulkExport 
        isExporting={isExporting}
        setIsExporting={setIsExporting}
      />

      <div className="space-y-4">
        <h2 className="text-2xl font-bold">Individual Table Exports</h2>
        <p className="text-muted-foreground">
          Export individual tables as CSV files.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {tableConfigs.map(({ name, pretty }) => (
            <TableExport
              key={name}
              tableName={name}
              prettyName={pretty}
              isExporting={isExporting}
              setIsExporting={setIsExporting}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
